import { savedTrplColor } from "../../constants";

export default {
  groupsTabs: {
    '& .MuiTab-root': {
      minWidth: '50px',
      padding: '0 12px 10px 12px',
      fontSize: '12px',
      display: 'flex',
      justifyContent: 'flex-end',
    },
    '& .MuiTabs-root': {
      minHeight: '32px',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: '#222029',
      height: '2px',
      marginBottom: '3px',
    },
    '& .MuiTab-wrapper': {
      textAlign: 'center',
      textTransform: 'none',
      flexDirection: 'row',
      lineHeight: 1.3,
      marginBottom: '3px',
      '&:hover': {
        color: '#4c4c4c',
      }
    },
    '& .Mui-selected .MuiTab-wrapper': {
      fontWeight: 550,
      color: '#4c4c4c',
    },
    '& .MuiTab-labelIcon .MuiTab-wrapper > *:first-child': {
      marginBottom: 0,
    },
    '& .MuiTab-labelIcon': {
      minHeight: 24,
    },
    '& .MuiTab-labelIcon .MuiTab-wrapper': {
      minHeight: 0,
    },
  },
  circleBtn: {
    display: 'flex',
    cursor: 'pointer',
    padding: '5px 20px',
    borderRadius: '20px',
    alignItems: 'center',
    background: 'rgba(255, 255, 255, 0.4)',
    justifyContent: 'center',
    textTransform: 'uppercase',
    outline: '#dbd9e7 solid 1px',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.9)',
    },
  },
  headerBtnsContainer: {
    top: '4px',
    right: '10px',
    zIndex: '10000',
    display: 'flex',
    position: 'fixed',
    alignItems: 'center',
  },
  headerBtn: {
    color: '#ffff',
    marginRight: '20px',
    padding: '0 12px',
    textTransform: 'capitalize',
    opacity: '0.9',
    '&:hover': {
      opacity: '1.0',
    },
  },
  headerImportantBtn: {
    background: '#222029',
    color: '#FFFF',
    height: '25px',
    width: '120px',
    margin: '8px',
    opacity: '0.9',
    textTransform: 'capitalize',
    '&:hover': {
      color: '#FFFF',
      opacity: '1.0',
      background: '#222029',
    },
  },
  headerSecondaryBtn: {
    background: '#EEECF8',
    color: '#222029',
    height: '25px',
    width: '120px',
    margin: '8px',
    textTransform: 'capitalize',
    '&:hover': {
      background: '#eeecf8',
    },
  },
  appBar: {
    background: '#222029',
    boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.02)',
    position: 'fixed',
    top: '0',
    zIndex: '10000',
    height: '32px',
  },
  toolBar: {
    minHeight: '0',
    padding: '4px',
  },
  closeBtn: {
    margin: '8px',
    padding: '8px',
  },
  headerCloseMenu: {
    top: '30px',
    left: '10px',
    position: 'fixed',
    borderRadius: '4px',
    background: '#FFFF',
    boxShadow: '0px 3px 5px rgba(0, 0, 2, 0.1)',
    padding: '10px',
    zIndex: '10000',
  },
  headerMoreMenu: {
    top: '30px',
    right: '10px',
    position: 'fixed',
    borderRadius: '4px',
    background: '#FFFFFF',
    boxShadow: '0px 3px 5px rgba(0, 0, 2, 0.1)',
    padding: '10px 0',
  },
  groupMainContainer: {
    boxShadow: 'none',
    background: 'transparent',
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '50px',
  },
  ancestorTitle: {
    display: 'flex',
    fontSize: '20px',
  },
  predicateTitle: {
    textTransform: 'uppercase',
    color: 'darkslategray',
    fontSize: '12px',
  },
  rstInfoPopover: {
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
  },
  rstRenderPartTrplContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  height42: {
    height: '42px',
  },
  addNewDateContainer: {
    width: '100%',
  },
  rstInfoContainer: {
    display: 'flex',
    whiteSpace: 'nowrap',
    minWidth: '40px',
  },
  rstInfoId: {
    marginRight: '10px',
  },
  rstInfo: {
    display: 'flex',
    flexDirection: 'column',
  },
  rstInfoTitle: {
    fontSize: '12px',
    color: '#4E4C4C',
  },
  rstConceptLink: {
    textDecoration: 'underline',
    color: 'grey',
    fontSize: '10px',
  },
  rstInfoType: {
    color: 'grey',
    fontSize: '10px',
  },
  rstEditRow: {
    borderTop: '1px solid #ebf0f8',
    borderBottom: '1px solid #ebf0f8',
    '&:first-child': {
      borderTop: 'none',
    },
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  trplContainer: {
    padding: '4px 10px 4px 10px',
  },
  rstIconBtn: {
    zIndex: '10',
    fontSize: '22px',
    color: '#B9BBCD',
    position: 'relative',
    transition: '0.1s',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  rstIconBtnRed: {
    '&:hover': {
      color: 'red',
      transition: '0.1s',
    },
  },
  rstIconBtnBlue: {
    '&:hover': {
      color: '#347CFF',
      transition: '0.1s',
    },
  },
  rstIconBtnGreen: {
    '&:hover': {
      color: '#00f21c',
      transition: '0.1s',
    },
  },
  setDeleteTrplBtnsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    marginLeft: '5px',
    width: '50px',
    flexShrink: '0',
    justifyContent: 'center',
    minHeight: '24px',
  },
  groupContainer: {
    width: '100%',
    margin: '5px',
  },
  groupScrollableContainer: {
    height: '100%',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '5px',
      height: '5px',
    },
  },
  groupHeading: {
    padding: '6px',
    fontSize: 12,
    letterSpacing: '0.1px',
    whiteSpace: 'nowrap',
    color: '#414349',
    fontWeight: 600,
    zIndex: 2,
  },
  modalContentBackground: {
    background: '#EEECF8',
  },
  checkboxTrplContainer: {
    padding: '3px',
    display: 'inline-flex',
  },
  groupLoaderOverlay: {
    position: 'absolute',
    zIndex: '2',
    top: '25px',
    left: '0',
    right: '0',
    bottom: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255,255,255,0.85)',
  },
  trplTextField: {
    padding: '0',
  },
  trplTextFieldInput: {
    border: 'none',
    fontSize: '12px',    
    color: '#4E4C4C',
    background: '#e8ebf5',
    // '&:focus': {
    //   background: '#d3fff4 !important', //'#DBD9E7 !important',
    // },
    // '&:hover': {
    //   background: '#eeecf8',
    // },
    
  },
  trplTextUrlInput: {
    maxHeight: '24px',
    fontSize: '12px',
    color: '#596686',
    background: '#e8ebf5',
    textDecoration: 'underline',
  },
  keyboardTimeControl: {
    '& .MuiInputAdornment-positionEnd': {
      marginLeft: '2px',
    },
    '& .MuiIconButton-root': {
      '&:hover': {
        background: 'transparent',
      },
    },
    '& .MuiFormHelperText-root': {
      display: 'none',
    },
  },
  keyboardTimeControlIcon: {
    fontSize: '22px',
    color: '#8589AC',
    '&:hover, &:focus': {
      color: '#222029',
    },
    marginRight: '5px',
  },
  trplEdited: {
    background: '#d3fff4 !important',
    minHeight: '23px !important',
    outline: '1px solid #d3fff4',
    '&:hover, &:focus': {
      outline: '1px solid rgb(58, 234, 184)',
    },
  },
  trplVirtual: {
    background: 'rgb(198, 234, 241)',
    outline: '1px solid #def0f5',
    '&:hover, &:focus': {
      outline: '1px solid rgb(114, 220, 231)',
    },
  },
  trplWithValue: {
    background: savedTrplColor + ' !important',
    minHeight: '23px !important',
    outline: `1px solid ${savedTrplColor}`,
    '&:hover, &:focus': {
      outline: '1px solid rgb(212, 220, 98)',
    },
  },
  mandatoryField: {
    background: 'rgb(255, 217, 170) !important',
    outline: `1px solid rgb(255, 217, 170)`,
    '&:hover, &:focus': {
      outline: '1px solid rgb(233, 171, 152)',
    },
  },
  trplEmpty: {
    width: '-webkit-fill-available',
    padding: '0 5px',
    minHeight: '19px',
    maxHeight: '24px',
    minWidth: '30px',
    outline: `1px solid #e8ebf5`,
    '&:hover, &:focus': {
      outline: '1px solid rgb(197, 197, 244)',
    },
  },
  notEditableTrplWithValue: {
    backgroundColor: '#eeeee5 !important',
    outline: '1px solid #eeeee5',
  },
  notEditableVirtualTrpl: {
    backgroundColor: 'rgb(231, 245, 249) !important',
    outline: '1px solid rgb(231, 245, 249)',
  },
  // fuzzyVal: {
  //   display: 'none',
  // },
  // fuzzy_parent: {
  //   '&:hover': {
  //     '& .fuzzy-val > *:first-child': {
  //       display: 'block',
  //     },
  //     '& .fuzzy-option-mark': {
  //       display: 'none',
  //     }
  //   }
  // },
  parentCustomBlock: {
    borderLeft: '1px solid #eeecf8',
    borderBottom: '1px solid #eeecf8',
    '&:hover': {
      backgroundColor: '#ffff',
      //boxShadow: '0px 1px 2px rgba(0, 0, 2, 0.1)',
      '& .custom-trpl-block': {
        
      }
    }
  },
  addCustomBlock: {
    height: '24px',
    '&:hover': {
      //backgroundColor: '#ffff',
    }
  },
  trplCheckbox: {
    padding: '0px',
    '& .MuiSvgIcon-root': {
      fontSize: '18px',
    },
  },
  trplIsDefault: {
    outline: '1px dashed #B9BBCD',
    backgroundColor: '#fff',
  },
  trplIsDefaultEnabled: {
    outline: '1px dashed #B9BBCD',
    fontSize: '12px',
  },
  trplSelectIsDefault: {
    outline: '1px dashed #B9BBCD',
  },
  trplFileLinkContainer: {
    minWidth: '30px',
    display: 'flex',
    overflow: 'auto',
    paddingLeft: '5px',
    padding: '4px 5px 4px 5px',
    backgroundColor: savedTrplColor,//'#ddeed59e', //'#F2EEE1',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '&::-webkit-scrollbar-thumb': {
      display: 'none',
    },
  },
  timezonesSelectClasses: {
    display: 'flex',
    alignItems: 'center',
    color: '#4c4c4c',
    width: '25px',
    padding: '0 5px',
    height: '24px !important',
    maxWidth: '30px',
    fontSize: '10px',
  },
  trplFileLink: {
    padding: '0',
    color: '#596686',
    height: '17px',
    textDecoration: 'underline',
    fontSize: '12px',
    wordBreak: 'break-all',
  },
  unsavedNewTrpl: {
    outline: '#cec1ff solid 2px',
    '&:focus': {
      outline: '#cec1ff solid 2px',
    },
  },
  accordeon: {
    '& .MuiCollapse-hidden': {
      display: 'none',
    },
    '&:before': {
      display: 'none',
    },
  },
  accordeonExpandIcon: {
    '& .MuiSvgIcon-root': {
      fontSize: '20px',
    },
  },
  accordeonSummary: {
    '& .MuiExpansionPanelSummary-content.Mui-expanded': {
      margin: '12px 0',
    },
  },
  itemSelect: {
    maxWidth: '40px',
  },
  autocompleteContainer: {
    top: '24px',
    left: '0px',
    right: '0px',
    width: '100%',
    zIndex: '9999',
    cursor: 'auto',
    overflow: 'auto',
    background: '#fff',
    position: 'absolute',
    borderLeft: '1px solid #ccc',
    borderRight: '1px solid #ccc',
    borderBottom: '1px solid #ccc',
    boxShadow: '1px 2px 2px #E8E8E8',
    boxSizing: 'border-box',
  },
  autocompleteEl: {
    display: 'flex',
    alignItems: 'center',
    padding: '2px 3px',
    '&:hover': {
      background: '#fafafa',
      cursor: 'pointer',
    },
  },
  editIconContainer: {
    display: 'flex',
    marginLeft: '22px',
    alignItems: 'center',
  },
  editNodeIcon: {
    color: '#B9BBCD',
    fontSize: '20px',
    '&:hover': {
      color: '#222029',
      cursor: 'pointer',
    },
  },
  notValidFileTrpl: {
    width: '100%',
    color: 'red',
    height: '24px',
    display: 'flex',
    fontSize: '12px',
    alignItems: 'center',
  },
  predicateSearch: {
    width: '100%',
    height: '24px',
    fontSize: '12px',
    border: 'none',
    color: '#4C4C4C',
    padding: '0 0 0 36px',
    backgroundColor: '#e8ebf5',
  },
  predicateSearchIcon: {
    marginRight: '-25px',
    paddingLeft: '5px',
    zIndex: 100,
    flexShrink: '0',
    color: '#B9BBCD',
    fontSize: '20px',
  },
  predicateSearchClear: {
    marginLeft: '-30px',
    color: '#B9BBCD',
    fontSize: '22px',
    cursor: 'pointer',
    '&:hover': {
      color: '#4E4C4C',
    },
  },
};
